import indicooApiServices from '../../api/indicoo';
import { fetchWithStaleCache } from '../../utils/staleCache';

const INFO_CACHE_KEY = 'app-infos';
const INFO_CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6h: só evita popular cache/loading em excesso, revalidação acontece sempre

export default {
  setSignupType: ({ commit }, { signupType }) => {
    commit('SET_SIGNUP_TYPE', signupType);
  },

  getInfos: async ({ commit }) => {
    commit('SET_INFO_LOADING', true);
    try {
      return await fetchWithStaleCache(INFO_CACHE_KEY, {
        ttlMs: INFO_CACHE_TTL_MS,
        fetcher: async () => {
          const { data } = await indicooApiServices.getInfo();
          return data || {};
        },
        onData: (data, { fromCache }) => {
          commit('SET_INFO', data);
          // Se veio do cache, já temos algo pra mostrar: tira o loading
          // enquanto a chamada real acontece em paralelo (standby do free tier).
          if (fromCache) commit('SET_INFO_LOADING', false);
        },
      });
    } catch (error) {
      return {};
    } finally {
      commit('SET_INFO_LOADING', false);
    }
  },
};
